module.exports = __webpack_public_path__ + "static/img/902befd5f32a8caf4ca79b55d39ee25a.902befd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg
// module id = d2Su
// module chunks = 0